import styled from 'styled-components'

const SubSectionTitle = styled.h4`
  margin: 0 0 10px;
  color: ${(p) => p.theme.FONT_COLOR};
  font-weight: 700;
  font-size: ${(p) => p.theme.font.size.l};
  line-height: 21px;
`

export default SubSectionTitle
